<template>
    <v-card height="326" elevation="0" style="border-radius: 10px">
        <v-card-text style="box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7)">
            <v-row no-gutters>
                <v-col
                    cols="12"
                    lg="12"
                    class="mb-1"
                    style="width: 330px; height: 286px; overflow-y: scroll; overflow-x:hidden; "
                >
                    <v-row no-gutters>
                        <v-col cols="12" lg="12" class="d-flex">
                            <v-icon class="mr-3" small color="#255D98">mdi-information</v-icon>
                            <div class="my-1 prompt-title">{{ $t('message.qualifiedApplicants.suggestion') }}</div>
                        </v-col>
                        <v-col cols="12" lg="12">
                            <div class="mb-5 mt-2 ml-2 mr-3 sarabun-16">
                                <div class="d-flex column">
                                    <li class="mr-n2"></li>
                                    <label class="pa-0"
                                        >{{ $t('message.qualifiedApplicants.guide.content1') }}</label
                                    >
                                </div>
                                <div class="d-flex column">
                                    <li class="mr-n2"></li>
                                    <label class="pa-0"
                                        >{{ $t('message.qualifiedApplicants.guide.content2') }}</label
                                    >
                                </div>
                                <div class="d-flex column ml-6">
                                    <li class="mr-n2"></li>
                                    <label class="pa-0"
                                        >{{ $t('message.qualifiedApplicants.guide.content3') }}
                                        <a
                                            href="https://schooney-dev-01.azurewebsites.net/academic/year"
                                            class="
                                                prompt-underline
                                                text-decoration-underline
                                            "
                                            >{{ $t('message.qualifiedApplicants.guide.content4') }}</a
                                        > {{ $t('message.qualifiedApplicants.guide.content5') }}</label
                                    >
                                </div>
                                <div class="d-flex column ml-6">
                                    <li class="mr-n2"></li>
                                    <label class="pa-0"
                                        >{{ $t('message.qualifiedApplicants.guide.content6') }}
                                        <a
                                            href="https://schooney-dev-01.azurewebsites.net/academic-year/classroom"
                                            class="
                                                prompt-underline
                                                text-decoration-underline
                                            "
                                            >{{ $t('message.qualifiedApplicants.guide.content7') }}</a
                                        >{{ $t('message.qualifiedApplicants.guide.content8') }}</label
                                    >
                                </div>
                                <div class="d-flex column ml-6">
                                    <li class="mr-n2"></li>
                                    <label class="pa-0"
                                        >{{ $t('message.qualifiedApplicants.guide.content9') }} <br /><strong
                                            >*</strong
                                        >
                                        {{ $t('message.qualifiedApplicants.guide.content10') }}</label
                                    >
                                </div>
                                <div class="d-flex column ml-6">
                                    <li class="mr-n2"></li>
                                    <label class="pa-0"
                                        >{{ $t('message.qualifiedApplicants.guide.content11') }}
                                        <a
                                            href="https://schooney-dev-01.azurewebsites.net/managements/students"
                                            class="
                                                prompt-underline
                                                text-decoration-underline
                                            "
                                            >{{ $t('message.qualifiedApplicants.guide.content12') }}</a
                                        ></label
                                    >
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "QualifiedGuide",
};
</script>
